import React from "react";

const LABEL = "Laster ...";

export function StardustSparksOnlyIcon({ size = 32, className, speed = 1 }) {
  const dot = size / 4;
  const gap = dot / 1.5;
  const dur = `${speed}s`;
  return (
    <svg
      width={size}
      height={dot}
      viewBox={`0 0 ${size} ${dot}`}
      className={className}
      role="status"
      aria-label={LABEL}
    >
      {[0, 1, 2].map((i) => (
        <circle
          key={i}
          cx={dot / 2 + i * (dot + gap)}
          cy={dot / 2}
          r={dot / 2}
          style={{ animation: `ng-fade ${dur} ${i * speed * 0.33}s infinite` }}
          fill="currentColor"
        />
      ))}
      <style>{`
        @keyframes ng-fade { 0%,80%,100%{opacity:0;} 40%{opacity:1;} }
        @media (prefers-reduced-motion: reduce) { circle { animation: none; opacity: 1; } }
      `}</style>
    </svg>
  );
}

function Ring({ size = 32, className, speed = 1 }) {
  const stroke = size / 8;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      className={className}
      role="status"
      aria-label={LABEL}
    >
      <circle
        cx="25"
        cy="25"
        r={20}
        fill="none"
        stroke="currentColor"
        strokeWidth={stroke}
        strokeDasharray={125}
        strokeDashoffset={100}
        style={{ transformOrigin: "center", animation: `ng-spin ${speed}s linear infinite` }}
      />
      <style>{`
        @keyframes ng-spin { to { transform: rotate(360deg); } }
        @media (prefers-reduced-motion: reduce) { circle { animation: none; opacity: 1; } }
      `}</style>
    </svg>
  );
}

export function NettgravSpinner(props) {
  return <Ring {...props} />;
}

export function StardustSpinnerIcon(props) {
  return <Ring {...props} />;
}

export function WormholeSpinnerIcon(props) {
  return <Ring {...props} />;
}

export function StardustSparksOrganicIcon(props) {
  return <StardustSparksOnlyIcon {...props} />;
}

export const AntdNettgravSpinner = (props) => <StardustSparksOnlyIcon {...props} />;
